import Modal from "components/modal";
import CloseIcon from "assets/icons/close.svg";
import { Button } from "components/button";

export default function DetailedBreakdownModal({
  setModalOpen,
  modalOpen,
  presortWeight,
  receivedWeight,
  postsortWeight,
  replayWeight,
  paymentWeight,
  replayPercentage,
  takebackMethod,
}) {
  const nonEligibleWeight = Math.max(0, receivedWeight - postsortWeight);

  const percentage = replayPercentage
    ? replayPercentage
    : (replayWeight * 100) / postsortWeight;

  return (
    <Modal
      setModalOpen={setModalOpen}
      modalOpen={modalOpen}
      className="flex flex-col justify-between min-h-[400px] w-[min(800px,90vw)]"
    >
      <div className="flex flex-col gap-6 py-4">
        <div className="flex justify-between mb-4">
          <h2 className="text-4xl font-semibold leading-none">
            Detailed breakdown
          </h2>
          <div className="cursor-pointer" onClick={() => setModalOpen(false)}>
            <img src={CloseIcon} alt="" variant="secondary" />
          </div>
        </div>

        <div>
          <div className="grid grid-cols-2 gap-4 py-4 px-6 bg-gray-300 bg-opacity-25 border-t border-black">
            <div className="text-lg font-semibold">Description</div>
            <div className="text-lg font-semibold text-right">Weight (lbs)</div>
          </div>

          <div className="space-y-0">
            <div className="grid grid-cols-2 gap-4 py-4 px-6 border-b-[2px] border-gray-300">
              <div>
                <div className="font-medium">Your estimate</div>
                <div className="text-sm text-tertiary">
                  The weight you estimated.
                </div>
              </div>
              <div className="text-right font-medium">
                {parseFloat(presortWeight).toFixed(2)}
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4 py-4 px-6 border-b border-gray-300">
              <div>
                <div className="font-medium">Received</div>
                <div className="text-sm text-tertiary">
                  Total confirmed weight of your trade-in.
                </div>
              </div>
              <div className="text-right font-medium">
                {parseFloat(receivedWeight).toFixed(2)}
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4 py-4 px-6 border-b border-gray-300">
              <div>
                <div className="font-medium">Non-eligible items</div>
                <div className="text-sm text-tertiary">
                  Total weight of items that were not accepted.
                </div>
              </div>
              <div className="text-right font-medium">
                {parseFloat(nonEligibleWeight).toFixed(2)}
              </div>
            </div>

            {takebackMethod === "mail" && (
              <div className="grid grid-cols-2 gap-4 py-4 px-6 border-b border-gray-300">
                <div>
                  <div className="font-medium">Donated to LEGO Replay</div>
                  <div className="text-sm text-tertiary">
                    Donated bricks will not earn a reward.
                  </div>
                </div>
                <div className="text-right font-medium">
                  {parseFloat(replayWeight).toFixed(2)}{" "}
                  <span className="text-gray-600">
                    ({Math.round(percentage)}%)
                  </span>
                </div>
              </div>
            )}

            <div className="grid grid-cols-2 gap-4 py-4 px-6 bg-gray-300 bg-opacity-25 border-b border-black font-semibold text-lg">
              <div>Total eligible for reward:</div>
              <div className="text-right">
                {parseFloat(paymentWeight).toFixed(2)}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex justify-start">
        <Button
          className=""
          variant="secondary"
          onClick={() => setModalOpen(false)}
        >
          Close
        </Button>
      </div>
    </Modal>
  );
}
